<template>
  <div :class="getAlertClasses" role="alert">
    <div>
      <div v-if="title">
        <h4 class="alert-headline" v-html="title"></h4>
      </div>
      <div v-html="msg">
      </div>
    </div>

    <ci-awesome-icon v-if="closeable" :class="getIconClasses" icon="times" ratio="0.75" type="solid" @click="onIconClick" />
  </div>
</template>

<script>
import AwesomeIcon from '@/components/AwesomeIcon.vue';

export default {
  name: 'AlertItem',

  components: {
    'ci-awesome-icon': AwesomeIcon,
  },

  props: {
    closeable: {
      type: Boolean,
      default: false,
      required: false,
    },

    msg: {
      type: String,
      default: '',
      required: true,
    },

    title: {
      type: String,
      default: '',
      required: false,
    },

    type: {
      type: String,
      default: 'primary',
      required: true,
    },
  },

  computed: {
    getAlertClasses() {
      return {
        alert: true,
        'd-flex': true,
        'w-100': true,
        'alert-primary': this.type === 'primary',
        'alert-secondary': this.type === 'secondary',
        'alert-success': this.type === 'success',
        'alert-danger': this.type === 'danger',
        'alert-warning': this.type === 'warning',
        'alert-info': this.type === 'info',
        'alert-light': this.type === 'light',
        'alert-dark': this.type === 'dark',
      };
    },

    getIconClasses() {
      return {
        'ml-auto': true,
        'icon-primary': this.type === 'primary',
        'icon-secondary': this.type === 'secondary',
        'icon-success': this.type === 'success',
        'icon-danger': this.type === 'danger',
        'icon-warning': this.type === 'warning',
        'icon-info': this.type === 'info',
        'icon-light': this.type === 'light',
        'icon-dark': this.type === 'dark',
      };
    },
  },

  methods: {
    onIconClick() {
      this.$emit('alert-item:close');
    },
  },
};
</script>
